export const updateCartProduct = (productId: number, amount: number) => ({
  type: "@saga/UPDATE_CART_PRODUCT",
  payload: { productId, amount },
});
